import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as commonActions from "../../redux/actions/commonAction";
import SelectedDomainUserModalComponent from "../../components/SelectedDomainUserModal";

const SelectedDomainUserModal = (props, context) => {
    const userAuthReducer = useSelector((state) => state.userAuthReducer);

    const dispatch = useDispatch();

    return (
        <>
            <SelectedDomainUserModalComponent
                selectedDomainUsers={userAuthReducer.selectedDomainUsers}
                {...props}
            />
        </>
    )
}


export default SelectedDomainUserModal;